module.exports = __webpack_public_path__ + "static/models/road_straight_start_0.19cadea.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/road_straight_start_0.json
// module id = 533
// module chunks = 1